import React from 'react';
import { useTranslation } from 'react-i18next';

import './LrvWelcome.css';

interface WelcomeProps {
  name: string;
}

const LrvWelcome: React.FC<WelcomeProps> = ({ name }) => {
  const { t } = useTranslation();

  return (
    <div className='container'>
      <h1>{t('welcome.title', { name })}</h1>
      <p>{t('welcome.description')}</p>
    </div>
  );
};

export default LrvWelcome;
